import { MouseEvent, useEffect } from "react";
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState";
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store";

/* Protopia Ecosystem component */
export interface ILandingDragContainerProps {
   children: JSX.Element
}
const LandingDragContainer = (props: ILandingDragContainerProps): JSX.Element => {
    const isDrag                    = useLandingStore((state: ILandingStore) => state.isDrag)
    const zoom: number              = useLandingStore((state: ILandingStore) => state.zoom) 
    const translateX                = useLandingStore((state: ILandingStore) => state.translateX) 
    const translateY                = useLandingStore((state: ILandingStore) => state.translateY)   

    const startDragX                = useSyncState<number>(0)
    const startDragY                = useSyncState<number>(0) 

    useEffect(() => { 
        if( zoom <= 100) {
            useLandingStore.setState({ translateX: 0, translateY: 0 })
        }
    }, [ zoom ])
    
    const onDragStart = ( evt: MouseEvent ) => { 
        if(isDrag) {            
            var img = new Image();
            img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
            (evt as any).dataTransfer.setDragImage(img, 0, 0);
            (evt.target as Element).classList.add("no-drag")
            startDragX.set( evt.clientX )
            startDragY.set( evt.clientY ) 
        }
        
    }
    const onDrag = (evt: MouseEvent) => { 
        if(isDrag) {
            //useLandingStore.setState({ translateX: evt.clientX - startDragX.get() })
            //useLandingStore.setState({ translateY: evt.clientY - startDragY.get() })
            // startDragX.set( evt.clientX )
            // startDragY.set( evt.clientY )
        }
    }
    const onDragEnd = (evt: MouseEvent) => {  
        if(isDrag) {
            (evt.target as Element).classList.remove("no-drag")
            useLandingStore.setState({ translateX: translateX + evt.clientX - startDragX.get() })
            useLandingStore.setState({ translateY: translateX + evt.clientY - startDragY.get() }) 
        }
    }
    return <div 
        className="w-100 h-100 landing-transform-container" 
        style={{ 
            transform: `scale(${ zoom / 100 }) translateX(${translateX}px) translateY(${translateY}px)`
        }}
        draggable={ isDrag }
        onDragStart={ onDragStart }
        onDrag={onDrag}
        onDragEnd={onDragEnd}
    >
        {props.children}
    </div>
}
export default LandingDragContainer